import NotifyApiError from 'errors/apiError';

export default (config) => {
  const {
    netlib,
    apiWrap,
    accessToken,
    appName,
  } = config;

  const getAppPageTemplate = (pathLocation, onErrorCallback) => apiWrap({
    apiQueryCb: async () => {
      const { data } = await netlib.TemplateApi.getAppPageTemplate(
        accessToken,
        pathLocation,
        appName,
      );
      if (data?.code !== 200) {
        throw new NotifyApiError('getAppPageTemplate error', { message: data?.message, code: data?.code });
      }
      return data?.result?.templates;
    },
    apiErrorCb: onErrorCallback,
  });

  const updateAppPageTemplate = (pathLocation, templateData) => apiWrap({
    apiQueryCb: async () => {
      const { data } = await netlib.TemplateApi.updateAppPageTemplate(
        accessToken,
        pathLocation,
        appName,
        templateData.label,
        templateData.isActive,
        templateData.isFavorite,
        templateData.templateContent,
        `/${pathLocation}`,
        templateData.id,
      );
      if (data?.code !== 200) {
        throw new NotifyApiError('updateAppPageTemplate error', { message: data?.message });
      }
      return true;
    },
  });

  const getActiveTemplate = (pathLocation) => apiWrap({
    apiQueryCb: async () => {
      const { data } = await netlib.TemplateApi.getAppActiveTemplates(
        accessToken,
        pathLocation,
        appName,
      );
      if (data?.code !== 200) {
        throw new NotifyApiError('getActiveTemplate error', { message: data?.message });
      }
      return data?.result?.templates?.length ? data.result.templates[0] : [];
    },
  });

  const getTemplateById = (idSelectedTemplate) => apiWrap({
    apiQueryCb: async () => {
      const { data } = await netlib.TemplateApi.getTemplate(accessToken,
        idSelectedTemplate);
      if (data?.code !== 200) {
        throw new NotifyApiError('getTemplateById error', { message: data?.message });
      }
      return data?.result;
    },
  });

  const deleteTemplateById = (templateId) => apiWrap({
    apiQueryCb: async () => {
      const { data } = await netlib.TemplateApi.deleteAppPageTemplate(accessToken,
        templateId);
      if (data?.code !== 200) {
        throw new NotifyApiError('deleteTemplateById error', { message: data?.message });
      }
      return true;
    },
  });

  const createAppPageTemplate = (pathLocation, templateData) => apiWrap({
    apiQueryCb: async () => {
      const { data } = await netlib.TemplateApi.createAppPageTemplate(
        accessToken,
        appName,
        templateData.label,
        templateData.isActive,
        templateData.isFavorite,
        templateData.templateContent,
        pathLocation,
      );
      if (data?.code !== 200) {
        throw new NotifyApiError('createAppPageTemplate error', { message: data?.message });
      }
      return true;
    },
  });

  const getAppFavoriteTemplates = () => apiWrap({
    apiQueryCb: async () => {
      const { data } = await netlib.TemplateApi.getAppFavoriteTemplates(accessToken,
        appName);
      if (data?.code !== 200) {
        throw new NotifyApiError('getAppFavoriteTemplates error', { message: data?.message });
      }
      return data?.result?.templates;
    },
  });

  return {
    getAppPageTemplate,
    updateAppPageTemplate,
    getActiveTemplate,
    getTemplateById,
    deleteTemplateById,
    createAppPageTemplate,
    getAppFavoriteTemplates,
  };
};
